import { all, takeLatest, put } from 'redux-saga/effects';
import {
    STORE_FONT,
    GET_FONTS_LIST,
} from './constants';
import {
    requestFontsList,
    requestStoreFont
} from './api';
import {
    storeFontSuccess,
    getFontsListSuccess
} from './actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{fonts: *, type: string}>>}
 */
function* storeFont( actionObj ) {
    const fonts = yield requestStoreFont( actionObj.font );
    if ( fonts ) {
        yield put( storeFontSuccess( fonts, actionObj.widget ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{fonts: *, type: string}>>}
 */
function* getFontsList( actionObj ) {
    const fonts = yield requestFontsList();
    if ( fonts ) {
        yield put( getFontsListSuccess( fonts, actionObj.widget ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchFonts() {
    yield takeLatest( STORE_FONT, storeFont );
    yield takeLatest( GET_FONTS_LIST, getFontsList );
}

/**
 *
 * @returns {IterableIterator<AllEffect<IterableIterator<ForkEffect>>>}
 */
function* fontsSaga() {
    yield all( [
        watchFonts()
    ] );
}

export default fontsSaga;
